import {
  EMPTYSEARCH_NB_SUGGESTIONS_WITH_HISTORY,
  EMPTYSEARCH_NB_SUGGESTIONS_WITHOUT_HISTORY,
} from '../constants';
import type { SuggestionHit } from '../interfaces/algolia';
import type {
  StaticSuggestionType,
  Suggestion,
  SuggestionsGroup,
  SuggestionType,
} from '../interfaces/suggestions';
import { createStaticSuggestions } from './createStaticSuggestions';
import { createSuggestions } from './createSuggestions';

interface RawSuggestionsGroup {
  hits: SuggestionHit[];
  type: SuggestionType | StaticSuggestionType;
  index: string;
  queryID?: string;
  history?: string[];
  termQuery?: string;
  highlight?: boolean;
  staticSuggestions?: boolean;
  autocomplete?: boolean;
}

export const buildSuggestionsGroup = <T extends SuggestionHit>(
  {
    hits,
    type,
    index,
    queryID,
    history,
    termQuery,
    highlight = false,
    staticSuggestions = false,
    autocomplete = false,
  }: RawSuggestionsGroup,
  format?: (suggestion: T) => Suggestion,
): SuggestionsGroup => {
  if (!hits) return {};

  if (staticSuggestions) {
    return {
      items: createStaticSuggestions({
        type: type as StaticSuggestionType,
        maxLength: history?.length
          ? EMPTYSEARCH_NB_SUGGESTIONS_WITH_HISTORY
          : EMPTYSEARCH_NB_SUGGESTIONS_WITHOUT_HISTORY,
      }),
    };
  }

  return {
    items: createSuggestions<T>(
      {
        hits,
        history,
        termQuery,
        highlight,
        type,
        autocomplete,
      },
      format,
    ),
    queryDetails: {
      index,
      queryID,
    },
  };
};
